import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { Grid, Divider as MuiDivider, Typography as MuiTypography } from "@mui/material";
import { spacing } from "@mui/system";
import { roundOff } from "../../../utils/common";

import CustomDataGrid from "./CustomDataGrid";
import useReports from "../../../hooks/useReports";
import { useDialog } from "../../../contexts/DialogContext";
import { getTimeStamp, formatDate } from "../../../utils/common";
import Stats from "./../../../components/Stats";
import {
  LocalOffer as DiscountIcon,
  ReceiptLong as ReceiptLongIcon,
  CurrencyRupee as CurrencyRupeeIcon,
  AccountBalanceWallet as WalletIcon,
} from "@mui/icons-material";
const Divider = styled(MuiDivider)(spacing);

const Typography = styled(MuiTypography)(spacing);

function HoldReports() {
  const { getHoldReports, isLoading, holdReports, paging, downloadHoldReport } = useReports();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { openDialog } = useDialog();

  const [filterResetFunc, setFilterResetFunc] = useState(
    () => () => console.log("Refresh initialized"),
  );

  const currentPayload = {
    filters: [],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [
      {
        field: "startDate",
        sort: "desc",
      },
    ],
  };

  const [sortModel, setSortModel] = useState([
    {
      field: "startDate",
      sort: "desc",
    },
  ]);
  const [filterFormData, setFilterFormData] = useState();

  const [payload, setPayload] = useState(currentPayload);

  const fetchData = async () => {
    await getHoldReports(payload);
  };

  const refreshPage = () => {
    setPayload(currentPayload);
    setFilterFormData();
    filterResetFunc();
    setPaginationModel({
      page: 0,
      pageSize: 100,
    });
  };

  const onPageChange = (newPaginationModel) => {
    console.log(newPaginationModel, "pagepage");

    const pagination = {
      pageNumber: newPaginationModel.page === 0 ? 1 : newPaginationModel.page + 1,
      pageSize: newPaginationModel.pageSize, // Update pageSize dynamically
    };

    setPayload((prev) => ({ ...prev, pagination }));
    setPaginationModel(newPaginationModel);
  };

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 100,
  });

  useEffect(() => {
    fetchData();
  }, [payload]);

  const exportFile = async (fileType) => {
    await downloadHoldReport(fileType, payload);
  };

  const handleSortModelChange = (newModel) => {
    const formattedSort = newModel.map((item) => ({
      field: item.field,
      sort: item.sort,
    }));

    setSortModel(newModel);

    setPayload((prev) => ({
      ...prev,
      sortFields: formattedSort,
    }));
  };

  return (
    <React.Fragment>
      <Helmet title="SaaS Dashboard" />
      <Grid justifyContent="space-between" container spacing={6}>
        <Grid item>
          <Typography variant="h4" gutterBottom>
            Hold Statistics
          </Typography>
        </Grid>
      </Grid>
      <Divider my={4} />
      {/* <Grid container spacing={6}>
        <Grid item xs={12} sm={12} md={6} lg={3} xl>
          <Stats
            title="Discount"
            amount={"₹" + holdReports.holdReportSum.discount}
            chip="Monthly"
            bgcolor="#f43f5e"
            icon={DiscountIcon}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3} xl>
          <Stats
            title="Service Tax"
            amount={"₹" + roundOff(holdReports.holdReportSum.serviceTax)}
            chip="Annual"
            bgcolor="#8b5cf6"
            icon={ReceiptLongIcon}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3} xl>
          <Stats
            title="Plan Amount"
            amount={"₹" + roundOff(holdReports.holdReportSum.planAmount)}
            chip="Weekly"
            bgcolor="#3b82f6"
            icon={CurrencyRupeeIcon}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3} xl>
          <Stats
            title="Total Payable Amount"
            amount={"₹" + roundOff(holdReports.holdReportSum.finalInvoiceAmount)}
            chip="Weekly"
            bgcolor="#10b981"
            icon={WalletIcon}
          />
        </Grid>
      </Grid> */}

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <CustomDataGrid
            trans={t}
            addPage={null}
            editPage={null}
            refreshPage={refreshPage}
            downloadFile={exportFile}
            openDownloadDialog={null}
            id="radUsersHoldId"
            data={holdReports.data}
            rowCount={holdReports.paging.totalNumberOfRecords}
            paging={{
              page: holdReports.paging.pageNumber,
              pageSize: holdReports.paging.pageSize,
            }}
            onPaginationModelChange={onPageChange}
            isLoading={isLoading}
            sortModel={sortModel}
            handleSortModelChange={handleSortModelChange}
            setPayload={setPayload}
            payload={payload}
            setFilterResetFunc={setFilterResetFunc}
            filterFormData={filterFormData}
            setFilterFormData={setFilterFormData}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default HoldReports;
